import { memo } from "react"

const ComplaintHistory = () => {
  return (
    <>
      Lịch sử PA/KN
    </>
  )
}

export default memo(ComplaintHistory)